import {DxBaseCellRenderComponent} from "../dx-base-cell-render.component";
import {Component} from "@angular/core";
import {DxNciDictionary} from "../../../../../dx-nci-core/domain/dx-nci-dictionary";
import {ICellRendererParams} from "ag-grid-community";


@Component({
  selector: 'dx-dictionary-cell-render',
  templateUrl: './dx-dictionary-cell-render.component.html',
  styleUrls: ['./dx-dictionary-cell-render.component.css']
})
export class DxDictionaryCellRenderComponent extends DxBaseCellRenderComponent {
  /**
   * Спаравочник НСИ для колонки в которой находится данная ячека.
   * @name _dictionary
   * @type {DxNciDictionary}
   */
  private _dictionary: DxNciDictionary;

  constructor() {
    super();
  }

  protected _init(params: ICellRendererParams): void {
    super._init(params);
    const grid = this._params.grid;
    this._dictionary = grid.gridDicts.get(this._columnOptions.dataType.dictIdent);
    this.value = this.transform(this._params.value);
  }


  public transform(value: number): string {
    if(!value) return '';
    if(this._dictionary) {
      let dictItem = this._dictionary.elementIndex.get(value);
      if(dictItem) {
        return dictItem.name;
      }
    }
    return '' + value;
  }
}
